import { AbstractDataProviderV2 } from 'components/system/data-provider';
import { CustomerUpdateActive } from 'common/customers/services/types/CustomerUpdateActive';

export class CustomerActiveByIdDataProvider extends AbstractDataProviderV2<{}, {}, {}, CustomerUpdateActive> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/active');
    }
    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }
    list(): Promise<null> {
        return Promise.reject('Method is not available');
    }

    get(): Promise<null> {
        return Promise.reject('Method is not available');
    }
    add(): Promise<null> {
        return Promise.reject('Method is not available');
    }
}
